// @flow

import React from "react";

import { Route, Switch } from "react-router-dom";

import { NewToReece } from "../components/new-to-reece/index";
import { CanWeHelp } from "../components/can-we-help/index";
import { SafeOnlineShopping } from "../components/safe-online-shopping/index";

import { LoginContainer } from "./login-container";
import { RecoverContainer } from "./recover-container";
import { ResetPasswordContainer } from "./reset-password-container";

import { ServiceManager } from "../service/service-manager";

type Props = {
    serviceManager: ServiceManager
};

export function LoginPage(props: Props) {
    const Login = wrapService(LoginContainer, props);
    const Recover = wrapService(RecoverContainer, props);
    const Reset = wrapService(ResetPasswordContainer, props);
    return (
        <div className="login-page">
            <div className="content-container">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-xs-12 col-sm-7 col-md-8">
                            <Switch>
                                <Route path="/login" component={Login} />
                                <Route
                                    path="/password/recover"
                                    component={Recover}
                                />
                                <Route
                                    path="/password/reset"
                                    component={Reset}
                                />
                            </Switch>
                        </div>
                        <div className="col-xs-12 col-sm-5 col-md-4">
                            <NewToReece />
                            <CanWeHelp />
                            <SafeOnlineShopping />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

function wrapService(Comp: any, data: Props) {
    return (props: any) => (
        <Comp {...props} serviceManager={data.serviceManager} />
    );
}
